export default {
    notifications: {},
    rejectedNotificationTypes: [
        //Add unwanted notification types here.
    ]
}
